import React from 'react'
import { Spinner } from 'reactstrap'

export const SubmitButton = (props) => {
    const {
        loader = false,
        btnText = 'Submit',
        buttonType = 'submit',
        handleSubmit,
        className,
        disabled
        
    
    } = props;
    return (
        <button
        {...props}
            onClick={handleSubmit && handleSubmit}
            disabled={loader || disabled}
            type={buttonType}
            className={`main_button ${loader ? "disabled-button" : ""} ${className}`}
        >
            {loader ?
                <>
                    <Spinner size="sm">
                        Loading...
                    </Spinner>


                    <span>
                        {' '}Loading
                    </span>
                </>
                :
                <span>
                    {btnText}
                </span>
            }
        </button>
    )
}
